import React from "react";
import MatrixPage from "./MatrixPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface MatrixPageContainerProps extends RouteProps, withValidUserRoleProps {}

const MatrixPageContainer = (props: MatrixPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <MatrixPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(MatrixPageContainer);
